/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import VueCompositionAPI from '@vue/composition-api';
import _Menu from './menu.js';
import _HeadMenu from './head-menu.js';
import _Submenu from './submenu.js';
import _MenuItem from './menu-item.js';
import _MenuGroup from './menu-group.js';
import { withInstall } from '../utils/withInstall.js';
import mapProps from '../utils/map-props.js';
import './style/css.js';
import './type.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/defineProperty';
import './props.js';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import './v-menu.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import './head-menu-props.js';
import '../tabs/index.js';
import '../tabs/tabs.js';
import '../_chunks/dep-115a1bd3.js';
import '../tabs/props.js';
import '../tabs/tab-panel.js';
import '../tabs/tab-panel-props.js';
import '../hooks/useDestroyOnClose.js';
import '../config-provider/config-receiver.js';
import '../utils/mixins.js';
import '../tabs/tab-nav.js';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/debounce';
import 'tdesign-icons-vue';
import '../tabs/tab-nav-item.js';
import '../utils/event.js';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../utils/ripple.js';
import '../_common/js/utils/set-style.js';
import '../config.js';
import '../tabs/type.js';
import './submenu-props.js';
import '../common-components/fake-arrow.js';
import './menu-item-props.js';
import './menu-group-props.js';
import 'lodash/capitalize';

var Menu = withInstall(mapProps([{
  name: "value",
  event: ["change", "update:value"]
}, {
  name: "expanded",
  event: ["expand", "update:expanded"]
}], {
  model: {
    prop: "value",
    event: "change"
  }
})(_Menu), VueCompositionAPI);
var HeadMenu = withInstall(mapProps([{
  name: "value",
  event: ["change", "update:value"]
}, {
  name: "expanded",
  event: ["expand", "update:expanded"]
}], {
  model: {
    prop: "value",
    event: "change"
  }
})(_HeadMenu), VueCompositionAPI);
var Submenu = withInstall(_Submenu, VueCompositionAPI);
var MenuItem = withInstall(_MenuItem, VueCompositionAPI);
var MenuGroup = withInstall(_MenuGroup, VueCompositionAPI);

export { HeadMenu, Menu, MenuGroup, MenuItem, Submenu };
//# sourceMappingURL=index.js.map
